// import React, { useState } from 'react';
// import { SketchPicker } from 'react-color';
// import { Twitter } from 'react-color/lib/components/twitter/Twitter';

// const ColorSwitcher = () => {
    // var { Alpha } = require('react-color/lib/components/common');

    // <Twitter
    //     {...this.props}
    //     // pointer={CustomPointer}
    //     onChange={this.handleChange} />

    // const [state, setState] = useState({ background: '#fff' });

    // const handleChangeComplete = (color) => {

    //     setState({ background: color.hex });
    // };
    // console.log(state)
    // return (
    //     <SketchPicker onChangeComplete={handleChangeComplete} />

    // )

//     const [currentColor, setCurrentColor] = useState("#fff")
//     const handleOnChange = (color) => {
//         setCurrentColor(color.hex);
//     }

//     const appStyle = {
//         backgroundColor: currentColor,
        
//     }

//     return (
//         <div style={appStyle}>
//             <SketchPicker
//                 color={currentColor}
//                 onChangeComplete={handleOnChange}
//             />
//         </div>

//     )
// }

// export default ColorSwitcher

import React, { useState, useRef } from 'react';
import { TwitterPicker } from 'react-color';

const ColorSwitcher = ({ onColorChange }) => {
    const [currentColor, setCurrentColor] = useState("#fff");
    const [showPicker, setShowPicker] = useState(false);
    const colorPickerRef = useRef();
    const colorInputRef = useRef();

    const handleTogglePicker = () => {
        setShowPicker(!showPicker);
    };

    const handleColorChange = (color) => {
        setCurrentColor(color.hex);
        onColorChange(color.hex); // Llama a la función de actualización del formulario
        setShowPicker(false);
    };



    const appStyle = {
        backgroundColor: currentColor,
        width: '30px', 
        height: '30px',
        borderRadius: '8px',
    }

    const colorBoxStyle = {
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        border: '1.5px solid #d2cece',
        borderRadius: '8px',
    }

    return (
        <div>
            <div style={appStyle}>
                <div style={colorBoxStyle} onClick={handleTogglePicker}></div>
            </div>
            {showPicker && (
                <div
                    ref={colorPickerRef}
                    style={{ position: 'absolute', zIndex: '2' }}
                >
                    <TwitterPicker
                        color={currentColor}
                        onChangeComplete={handleColorChange}
                    />
                </div>
            )}
            <input
                ref={colorInputRef}
                type="text"
                value={currentColor}
                onChange={() => {}}
                style={{ display: 'none' }}
            />
        </div>
    )
}

export default ColorSwitcher;
